import axios from 'axios';
import config from './../../config';

export default (yamlFile) => {
  const baseURL = `${config.apiUrl}/update/${yamlFile}`;
  return axios.get(baseURL, {
    responseType: 'text',
  });
};
